import { combineReducers } from 'redux';

import { AppState } from './root.types';
import { basketReducer } from './basket';
import { notificationsReducer } from './notifications';
import { paymentReducer } from './payment';
import { checkoutReducer } from './checkout';

const rootReducer = combineReducers<AppState>({
    basketState: basketReducer,
    checkoutState: checkoutReducer,
    notificationsState: notificationsReducer,
    paymentState: paymentReducer
});

export default rootReducer;